'use strict';

export function LanguageController($scope, LanguageService, $window) {
  'ngInject';
  LanguageService.init();
  $scope.changeLanguage = function changeLanguage(lang) {
    LanguageService.set(lang);
    $scope.lang = lang;
    $window.location.reload();
  };
  $scope.lang = LanguageService.get();
}



// WEBPACK FOOTER //
// ./client/components/language/language.controller.js